const label = (key) => key.replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2");

export function formatProfileValue(value) {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number") return String(value);
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (Array.isArray(value)) return value.map(formatProfileValue).filter(Boolean).join(", ");
  if (typeof value === "object") {
    return Object.entries(value).map(([key, item]) => {
      const text = formatProfileValue(item);
      return text ? `${label(key)}: ${text}` : "";
    }).filter(Boolean).join("; ");
  }
  return "";
}

export function formatProfileList(value, separator = "; ") {
  return Array.isArray(value)
    ? value.map(formatProfileValue).filter(Boolean).join(separator)
    : formatProfileValue(value);
}
